import { NAME } from "./constants";

export const GET_USER_LOCKS = NAME + "GET_USER_LOCKS";
export const GET_LOCK_INFORMATION = NAME + "GET_LOCK_INFORMATION";

export const REQUEST_DEVICE_ACCESS = NAME + 'REQUEST_DEVICE_ACCESS';
export const DELETE_DEVICE_ACCESS = NAME + 'DELETE_DEVICE_ACCESS';